export default __webpack_public_path__ + "static/media/timbertech-ca.ed844d13.csv";